import { FormField, FormItem, FormControl } from "@/src/components/ui/form";
import { UploadInput } from "@/src/components/ui/upload";
import { OperatorForm } from "./operator.schema";

export function TermsAndConditions() {
  return (
    <>
      <h3 className="text-lg font-semibold">Terms and Conditions</h3>
      <div className="w-full max-w-[672px]">
        <FormField<OperatorForm, "termsAndConditions">
          name="termsAndConditions"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <UploadInput
                  accept="image/svg+xml, image/png, application/pdf"
                  onChange={field.onChange}
                  value={field.value}
                  ownerType="operator"
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </>
  );
}
